import script from "./StatsMixin.vue?vue&type=script&lang=js"
export * from "./StatsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__